import { type Icon, Yelp } from 'react-bootstrap-icons';

export interface PageTitleProps {
  title: string;
  subtitle?: string;
  icon?: Icon;
}

const PageTitle = ({ title, subtitle, icon: IconComponent = Yelp }: PageTitleProps) => {
  return (
    <div className="d-flex align-items-center gap-3 mb-4">
      {IconComponent && (
        <div className="fs-2 text-primary">
          <IconComponent size={42} />
        </div>
      )}
      <div>
        <h1 className="mb-0 mt-1 compound">{title}</h1>
        {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
      </div>
    </div>
  );
};

export { PageTitle };
